// src/common/SEO.jsx
// Reusable SEO component — har page mein sirf 1 line: <SEO config={SEOConfig.home} />

import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ config }) => {
  if (!config) return null;
  const { title, description, keywords, canonical } = config;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content="https://www.astrobhagya.com/favicon.png" />
      <meta property="og:site_name" content="AstroBhagya" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://www.astrobhagya.com/favicon.png" />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Heavenly Expectation Private Limited" />
    </Helmet>
  );
};

export default SEO;
